import { Component, OnInit, Input, Output, EventEmitter, forwardRef, OnChanges, SimpleChanges  } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RadioGroupComponent), multi: true },
  ]
})

export class RadioGroupComponent implements OnInit, OnChanges {
  propagateChange: any = () => {};
  onTouched = () => {};
  @Output() modelChange = new EventEmitter<string>();
  @Input() values: Array<RadioButton> = [];
  @Input() parentFormGroup: FormGroup;
  @Input() formControl: FormControl;

  private _model: string = '';

  constructor() { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
  }
  // Called when form is initialized, with form model's initial value
  writeValue(value: any) { if (value) this.model = value; }

  // Access to a function that informs the outside world about changes
  registerOnChange(fn) { this.propagateChange = fn; }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }

  get model() { return this._model; }

  set model(val) {
    this._model = val;
    this.propagateChange(this._model);
    this.modelChange.emit();
    this.onTouched();
  }

  trackBy(index, elem: RadioButton) {
    return elem.value;
  }
}

export class RadioButton {
  value: string;
  labelKey: string;
}
